import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './AppRoutes';

const App = () => {
  useEffect(() => {
    document.title = 'cloudmingle - Your Essential Guide to the Best Hotels in New Zealand';
  }, []);

  return (
    <Router>
        <AppRoutes />
    </Router>
  );
};

export default App;